import React, { useState, useEffect, useContext } from "react";
import { DatePicker } from "../../../components";
import { addDays } from "date-fns";
import restService from "../../../../restService";
import CampaignContext from "../../../../contexts/CampaignContext";
import { PulseLoader } from "react-spinners";

const GeneralPerformance = ({ state }) => {
  const [campaign] = useContext(CampaignContext);
  // const [state, setState] = useState([
  //   {
  //     startDate: addDays(new Date(), -7).setHours(0, 0, 0, 0),
  //     endDate: new Date().setHours(23, 59, 59, 0),
  //     key: "selection",
  //   },
  // ]);
  const [loading, setLoading] = useState(false);
  const [performanceChanges, setPerformanceChanges] = useState({
    blacklist: { value: 0, state: "" },
    ignored: { value: 0, state: "" },
    invalid: { value: 0, state: "" },
    staff: { value: 0, state: "" },
    total: { value: 0, state: "" },
    unique: { value: 0, state: "" },
    valid: { value: 0, state: "" },
    winIgnored: { value: 0, state: "" },
    wins: { value: 0, state: "" },
    uniqueParticipants: { value: 0, state: "" },
    _id: null,
  });
  const [generalPerformanceData, setGeneralPerformanceData] = useState({
    blacklist: 0,
    ignored: 0,
    invalid: 0,
    staff: 0,
    total: 0,
    unique: 0,
    valid: 0,
    winIgnored: 0,
    wins: 0,
    uniqueParticipants: 0,
    _id: null,
  });

  const getPerformance = (pastResult, currentResult) => {
    if (pastResult > currentResult) {
      return {
        state: "decrease",
        value: Number(
          (pastResult / (pastResult + currentResult)) * 100
        ).toFixed(2),
      }; // decrease
    } else if (pastResult < currentResult) {
      return {
        value: Number(
          (currentResult / (pastResult + currentResult)) * 100
        ).toFixed(2),
        state: "increase",
      }; // increase
    } else {
      return { value: Number(0).toFixed(2), state: "" };
    }
  };

  const handleWeeklyPerformance = async (currentResult) => {
    try {
      const {
        data: { data },
      } = await restService.Reports.generalPerformance(
        campaign.id,
        addDays(state[0].startDate, -7).toISOString().slice(0, -5),
        new Date(state[0].startDate).toISOString().slice(0, -5)
      );
      let pastWeekResults = {};

      if (Array.isArray(data)) {
        pastWeekResults = data[0];
      } else {
        pastWeekResults = data;
      }
      // past week's total entries percentage
      let totalEntriesPercentageChange = getPerformance(
        pastWeekResults?.total,
        currentResult?.total
      );

      // past week's total valid entries percentage
      let totalValidEntriesPercentage = getPerformance(
        pastWeekResults?.valid,
        currentResult?.valid
      );

      // past week's total invalid entries percentage
      let totalInValidEntriesPercentage = getPerformance(
        pastWeekResults?.invalid,
        currentResult?.invalid
      );

      // past week's total wins percentage
      let totalWinsPercentage = getPerformance(
        pastWeekResults?.wins,
        currentResult?.wins
      );

      // past week's total blacklist entries percentage
      let totalBlacklistPercentage = getPerformance(
        pastWeekResults?.blacklist,
        currentResult?.blacklist
      );

      // past week's total staff entries percentage
      let totalstaffPercentage = getPerformance(
        pastWeekResults?.staff,
        currentResult?.staff
      );

      // past week's total win ignored entries percentage
      let totalWinIgnoredPercentage = getPerformance(
        pastWeekResults?.winIgnored,
        currentResult?.winIgnored
      );

      // past week's total unique entries percentage
      let totalUniquePercentage = getPerformance(
        pastWeekResults?.unique,
        currentResult?.unique
      );

      // past week's total unique participants percentage
      let totalUniqueParticipants = getPerformance(
        pastWeekResults?.uniqueParticipants || 0,
        currentResult?.uniqueParticipants || 0
      );

      setPerformanceChanges({
        ...performanceChanges,
        invalid: totalInValidEntriesPercentage,
        wins: totalWinsPercentage,
        blacklist: totalBlacklistPercentage,
        staff: totalstaffPercentage,
        unique: totalUniquePercentage,
        total: totalEntriesPercentageChange,
        valid: totalValidEntriesPercentage,
        winIgnored: totalWinIgnoredPercentage,
        uniqueParticipants: totalUniqueParticipants,
      });
    } catch (error) {
      console.log(error);
    }
  };

  const cards = [
    {
      title: "Total Entries",
      value: generalPerformanceData?.total?.toLocaleString(undefined, {
        minimumFractionDigits: 0,
      }),
      icon: performanceChanges.total.state,
      performance: `${performanceChanges?.total?.value}% from last week`,
    },
    {
      title: "Total Valid Entries",
      value: generalPerformanceData?.valid?.toLocaleString(undefined, {
        minimumFractionDigits: 0,
      }),
      icon: performanceChanges?.valid?.state,
      performance: `${performanceChanges?.valid?.value}% from last week`,
    },
    {
      title: "Total Invalid Entries",
      value: generalPerformanceData?.invalid?.toLocaleString(undefined, {
        minimumFractionDigits: 0,
      }),
      icon: performanceChanges?.invalid?.state,
      performance: `${performanceChanges?.invalid?.value}% from last week`,
    },
    {
      title: "Total Wins",
      value: generalPerformanceData?.wins?.toLocaleString(undefined, {
        minimumFractionDigits: 0,
      }),
      icon: performanceChanges?.wins?.state,
      performance: `${performanceChanges?.wins?.value}% from last week`,
    },
    {
      title: "Total Blacklist Entries",
      value: generalPerformanceData?.blacklist?.toLocaleString(undefined, {
        minimumFractionDigits: 0,
      }),
      icon: performanceChanges?.blacklist?.state,
      performance: `${performanceChanges?.blacklist?.value}% from last week`,
    },
    {
      title: "Total Staff Entries",
      value: generalPerformanceData?.staff?.toLocaleString(undefined, {
        minimumFractionDigits: 0,
      }),
      icon: performanceChanges?.staff.state,
      performance: `${performanceChanges?.staff?.value}% from last week`,
    },
    {
      title: "Total Unique Participants",
      value:
        generalPerformanceData?.uniqueParticipants?.toLocaleString(undefined, {
          minimumFractionDigits: 0,
        }) || 0,
      icon: performanceChanges?.winIgnored?.state,
      performance: `${performanceChanges?.winIgnored?.value}% from last week`,
    },
    {
      title: "Total Unique Wins",
      value: generalPerformanceData?.unique?.toLocaleString(undefined, {
        minimumFractionDigits: 0,
      }),
      icon: performanceChanges?.unique.state,
      performance: `${performanceChanges?.unique?.value}% from last week`,
    },
  ];

  const getGeneralPerformance = async () => {
    setLoading(true);
    try {
      const {
        data: { data },
      } = await restService.Reports.generalPerformance(
        campaign.id,
        new Date(state[0].startDate).toISOString().slice(0, -5),
        new Date(state[0].endDate).toISOString().slice(0, -5)
      );

      if (Array.isArray(data)) {
        setGeneralPerformanceData(data[0]);
        handleWeeklyPerformance(data[0]);
      } else {
        setGeneralPerformanceData(data);
        handleWeeklyPerformance(data);
      }
      // console.log(data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getGeneralPerformance();
  }, [state]);

  // console.log(generalPerformanceData);

  return (
    <div className="shadow mb-8 bg-white py-6 px-6 w-full">
      <div className="flex mb-6 flex-col md:gap-0 gap-5 md:flex-row md:items-center md:justify-between">
        <p className="text-[#181818] text-base">General Performance</p>

        {/* <div className="border rounded">
          <DatePicker state={state} setState={setState} />
        </div> */}
      </div>

      {/* cards */}
      <div>
        {loading ? (
          <>
            <div className="h-full w-full flex items-center justify-center">
              <PulseLoader color="#FF6A3A" />
            </div>
          </>
        ) : (
          <div className="flex flex-wrap gap-4 justify-start align-center w-full mt-3">
            {cards.map((item, index) => (
              <div
                key={index}
                className="flex flex-col gap-1 border-[0.5px] border-[#A6A6A6] px-8 py-4 rounded justify-center align-center w-full md:w-1/4 lg:w-[23.8%]"
              >
                <div className="flex flex-col gap-1 justify-center align-center w-full">
                  <p className="text-[#848484] text-xs">{item.title}</p>
                  <h4 className="text-[#24211D] text-2xl font-[600]">
                    {item.value}
                  </h4>
                </div>
                <div className="flex gap-2 align-center w-full">
                  {item.icon === "increase" ? (
                    <svg
                      width="10"
                      height="7"
                      viewBox="0 0 10 7"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-full"
                    >
                      <path
                        d="M5.08696 0L9.3366 6.75H0.837322L5.08696 0Z"
                        fill="#00C74C"
                      />
                    </svg>
                  ) : item.icon === "decrease" ? (
                    <svg
                      width="10"
                      height="7"
                      viewBox="0 0 10 7"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-full"
                    >
                      <path
                        d="M5.04918 7L0.799544 0.249999L9.29882 0.25L5.04918 7Z"
                        fill="#FF0000"
                      />
                    </svg>
                  ) : (
                    <></>
                  )}

                  <p className="text-[#848484] text-[12px]">
                    {item.performance}
                  </p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default GeneralPerformance;
